const type = 'SET_CARD_UNBLOCK_OUTCOME';

const setCardUnblockOutcome = (data) => ({
  data,
  type,
});

export { type };
export default setCardUnblockOutcome;
